module.exports = __webpack_public_path__ + "img/1.9bdc7221.jpg";